module.exports = {
  painter: require('./painter')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g@3.3.6@@antv/g/lib/renderers/canvas/index.js
// module id = 223
// module chunks = 0 1 2